import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { DataAccessFairsFacade } from '@planone/bau365/data-access-fair-data';
import { DataAccessTogglesFacade } from '@planone/shared/data-access-feature-flags';

import { combineLatest, Observable } from 'rxjs';

import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NewsfeedEnabledGuard {
  newsfeedDisabledToggle$: Observable<boolean | undefined>;

  constructor(
    private readonly router: Router,
    private readonly fairsFacade: DataAccessFairsFacade,
    private feature: DataAccessTogglesFacade
  ) {
    this.newsfeedDisabledToggle$ = this.feature.flag('kill-newsfeed');
  }

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    return combineLatest([this.newsfeedDisabledToggle$, this.fairsFacade.fairId$]).pipe(
      map(([newsfeedDisabled, fairId]) => {
        if (newsfeedDisabled) {
          return this.router.parseUrl(`/fairs/${fairId}/search`);
        } else {
          return true;
        }
      })
    );
  }
}
